import { Tokens } from "@accurx/design";
import styled from "styled-components";

const StyledButtonWrapper = styled.div`
    margin-top: ${Tokens.SIZES[1.5]};
`;

export { StyledButtonWrapper };
